module.exports = __webpack_public_path__ + "static/media/check-circle.8dc25d97.svg";